import type { LocationGeocodedName } from '@carvia/ros-client-types';
import type { AddressComponent } from '@/entities/map-api.entity.ts';

export function extractGeocodedAddressFromAddressComponents(
  addressComponents: AddressComponent[] | undefined,
  displayName: string,
): LocationGeocodedName {
  const country = addressComponents
    ?.find((component) => component.types?.includes('country'))
    ?.short_name?.toUpperCase();
  const zip = addressComponents?.find((component) =>
    component.types?.includes('postal_code'),
  )?.long_name;
  const townComponent = addressComponents?.find(
    (component) =>
      component.types?.includes('locality') || component.types?.includes('postal_town'),
  );
  const city = townComponent?.long_name || townComponent?.short_name;
  const route = addressComponents?.find((component) =>
    component.types?.includes('route'),
  )?.long_name;
  const streetNumber = addressComponents?.find((component) =>
    component.types?.includes('street_number'),
  )?.long_name;
  const street = route ? `${route}${streetNumber ? ` ${streetNumber}` : ''}` : undefined;

  return {
    displayName,
    ...(country ? { country } : {}),
    ...(street ? { street } : {}),
    ...(zip ? { zip } : {}),
    ...(city ? { city } : {}),
  };
}
